import { render, staticRenderFns } from "./FavoriteIndex.vue?vue&type=template&id=33538ad7&scoped=true&"
import script from "./FavoriteIndex.vue?vue&type=script&lang=js&"
export * from "./FavoriteIndex.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteIndex.vue?vue&type=style&index=0&id=33538ad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33538ad7",
  null
  
)

export default component.exports